import React, { useEffect, useState } from 'react';
import { fetchToplist } from '../../service/service';
import { currencyFormat } from '../../helpers/format';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  toplist_box: (props) => ({
    padding: '56px 40px',
    marginTop: '36px',
    backgroundColor: '#102b4e',
    color: props.place === 1 ? '#B7B09C' : '#FFF',
    fontWeight: 300,
    flex: '0 0 auto',
    borderRadius: '12px',
  }),
  heading: {
    fontFamily: '"DM Serif Display", serif',
    fontSize: '48px',
    fontWeight: 400,
    lineHeight: '1.2',
    textAlign: 'center',
    '&:first-letter': {
      textTransform: 'capitalize',
    },
  },
  place: {
    fontSize: '23px',
    fontFamily: '"DM Serif Display", serif',
  },
  placeNumber: {
    fontSize: '24px',
    paddingTop: '5px',
    paddingBottom: '23px',
    fontFamily: '"DM Serif Display", serif',
  },
  placeHeading: {
    fontSize: '16px',
    paddingBottom: '10px',
    fontFamily: '"DM Serif Display", serif',
  },
  placeContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    paddingRight: '24px',
  },
  resultContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
    paddingLeft: '24px',
  },
  label: {
    fontFamily: '"Inter", sans-serif',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '24px',
    color: '#cdced6',
  },
  value: {
    fontSize: '30px',
    fontFamily: '"Inter", sans-serif',
    fontWeight: '400',
    lineHeight: '1.2',
    letterSpacing: '-0.025em',
    order: '-9999',
  },
}));

function MyToplistListBox({
  user,
  type,
  year,
  month,
  token,
  salesType,
  heading,
  placeHeading,
  unit,
  list,
  customerId,
  district,
  yearTo,
  monthTo,
  week,
  spain,
  sweden,
}) {
  const [result, setResult] = useState({ place: 0, value: 0 });
  const classes = useStyles({ place: result.place });

  useEffect(() => {
    const theFetch = async () => {
      await fetchToplist(
        type,
        year,
        month,
        false,
        token,
        salesType,
        customerId ? null : user.userId,
        customerId ? customerId : null,
        district,
        yearTo,
        monthTo,
        week,
        spain,
        sweden
      ).then((res) => {
        if (res.result) setResult(res.result);
        else setResult({ place: 0, value: 0 });
      });
    };

    theFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, year, month, token, salesType, user, customerId, district]);

  if (!list) return null;

  let valueNext = null;
  let index = null;
  if (customerId) {
    index = list.map((l) => l.customerId).indexOf(customerId);
  } else {
    index = list.map((l) => l.userId).indexOf(user.userId);
  }

  if (index > 0) {
    valueNext = list[index - 1].value - result.value;
    valueNext = Math.round(valueNext * 100) / 100;
  }

  return (
    <Box className={classes.toplist_box}>
      <Box className={classes.heading}>{heading}</Box>
      <Box
        marginTop="24px"
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
      >
        <Box className={classes.placeContainer}>
          <Box className={classes.value}>{result.place}</Box>
          <Box className={classes.label}>
            {spain ? 'My ranking' : 'Min placering'}
          </Box>
        </Box>
        <Box className={classes.resultContainer}>
          <Box className={classes.value}>
            {unit === 'kr' || unit === 'EUR'
              ? `${currencyFormat(result.value, spain ? 'eur' : 'sek')} ${unit}`
              : `${result.value} ${unit}`}
          </Box>
          <Box className={classes.label}>{placeHeading}</Box>
        </Box>
      </Box>

      {valueNext ? (
        <Box>
          {'Avstånd till nästa: '}
          {unit === 'kr' || unit === 'EUR'
            ? `${currencyFormat(valueNext, spain ? 'eur' : 'sek')} ${unit}`
            : `${valueNext} ${unit}`}
        </Box>
      ) : null}
    </Box>
  );
}

export default MyToplistListBox;
